import React, {createContext} from 'react';
export const PartnerContext = createContext({});
